(() => {
  const CONTACT_FORM_SELECTOR = 'form[id^="ContactForm"]';
  const PENDING_CONTACT_KEY = 'chery_pending_contact_submission';

  function pushEvent(eventName, details = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...details,
    });
  }

  function eventDetails(element) {
    return {
      contact_method: element.dataset.contactMethod || undefined,
      lead_type: element.dataset.leadType || undefined,
      product_name: element.dataset.productName || undefined,
      sku: element.dataset.productSku || undefined,
      page_location: window.location.href,
    };
  }

  function preorderDetailsFromUrl() {
    const parameters = new URLSearchParams(window.location.search);
    return {
      productName: parameters.get('preorder_product')?.trim() || '',
      sku: parameters.get('preorder_sku')?.trim() || '',
    };
  }

  function setHiddenField(form, name, value) {
    let field = form.querySelector(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function prefillPreorderContactForm() {
    const preorder = preorderDetailsFromUrl();
    if (!preorder.productName && !preorder.sku) return;

    document.querySelectorAll(CONTACT_FORM_SELECTOR).forEach((form) => {
      form.dataset.leadType = 'preorder';
      setHiddenField(form, 'contact[request_type]', 'Preorder');
      setHiddenField(form, 'contact[preorder_product]', preorder.productName);
      setHiddenField(form, 'contact[preorder_sku]', preorder.sku);

      const message = form.querySelector('textarea[name="contact[comment]"]');
      if (message && !message.value.trim()) {
        message.value = [
          'Preorder request',
          preorder.productName ? `Product: ${preorder.productName}` : '',
          preorder.sku ? `SKU: ${preorder.sku}` : '',
        ].filter(Boolean).join('\n');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-conversion-event]');
    if (!target) return;

    const protocolLink = target.matches('a[href^="tel:"], a[href^="mailto:"]');
    if (!protocolLink) {
      pushEvent(target.dataset.conversionEvent, eventDetails(target));
      return;
    }

    event.preventDefault();
    let navigationStarted = false;
    const continueNavigation = () => {
      if (navigationStarted) return;
      navigationStarted = true;
      window.location.href = target.href;
    };
    pushEvent(target.dataset.conversionEvent, {
      ...eventDetails(target),
      event_callback: continueNavigation,
      event_timeout: 500,
    });
    window.setTimeout(continueNavigation, 500);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(CONTACT_FORM_SELECTOR);
    if (!form) return;

    const preorder = preorderDetailsFromUrl();
    const details = {
      lead_type: form.dataset.leadType || (preorder.productName || preorder.sku ? 'preorder' : 'contact'),
      product_name: preorder.productName || undefined,
      sku: preorder.sku || undefined,
      page_location: window.location.href,
    };
    sessionStorage.setItem(PENDING_CONTACT_KEY, JSON.stringify(details));
    pushEvent('contact_form_submit', details);
  });

  document.addEventListener('DOMContentLoaded', () => {
    prefillPreorderContactForm();

    const successfulForm = Array.from(document.querySelectorAll(CONTACT_FORM_SELECTOR))
      .find((form) => form.querySelector('.form-status-success'));
    const pendingSubmission = sessionStorage.getItem(PENDING_CONTACT_KEY);
    if (!successfulForm || !pendingSubmission) return;

    let details = {};
    try {
      details = JSON.parse(pendingSubmission);
    } catch (error) {
      details = { lead_type: 'contact', page_location: window.location.href };
    }
    pushEvent('contact_form_success', details);
    sessionStorage.removeItem(PENDING_CONTACT_KEY);
  });
})();
